<template>
    <div>
        <router-view :url="url" v-on:updateTitle="updateTitle"></router-view>
    </div>
</template>

<script>
export default {
  name: 'User',
  computed: {
    url: function () {
      return process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/user'
    }
  },
  created: function () {
    this.$emit('activeMenu', '/admin/user')
    this.$emit('newLink', '/admin/user/create')
    this.$emit('updateDisable', false)
  },
  methods: {
    updateTitle (val) {
      this.$emit('updateTitle', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/user/User.vue